import {Pipe, PipeTransform} from '@angular/core';
import {Timezone} from '../../@core/utils/timezone.service';

@Pipe({name: 'timezone'})
export class TimezonePipe implements PipeTransform {
    transform(t: Timezone): string {
        return `(${t.name}): ${t.mainCities.join(', ')}`;
    }
}
